import React from 'react';

interface SOLIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export const SOLIcon: React.FC<SOLIconProps> = ({
  width = 32,
  height = 32,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="16" cy="16" r="16" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.87319 20.4103C9.93343 20.344 10.0068 20.2911 10.0886 20.2549C10.1704 20.2187 10.2589 20.1999 10.3484 20.1999L25.0108 20.2119C25.0733 20.212 25.1343 20.2303 25.1865 20.2644C25.2389 20.2986 25.2801 20.3472 25.3052 20.4043C25.3304 20.4615 25.3384 20.5247 25.3283 20.5863C25.3182 20.6479 25.2905 20.7053 25.2484 20.7515L22.126 24.1895C22.0657 24.2557 21.9923 24.3087 21.9105 24.3449C21.8285 24.3811 21.74 24.3999 21.6504 24.3999L6.9884 24.3879C6.92596 24.3877 6.8649 24.3695 6.81263 24.3353C6.76037 24.3011 6.71915 24.2525 6.69399 24.1954C6.66883 24.1383 6.6608 24.075 6.67089 24.0134C6.68097 23.9518 6.70874 23.8944 6.7508 23.8483L9.87319 20.4103ZM25.2484 17.5483C25.2905 17.5944 25.3182 17.6518 25.3283 17.7134C25.3384 17.775 25.3304 17.8383 25.3052 17.8954C25.2801 17.9525 25.2389 18.0011 25.1865 18.0353C25.1343 18.0695 25.0733 18.0877 25.0108 18.0879L10.3488 18.0999C10.2593 18.0999 10.1707 18.0811 10.0888 18.0449C10.0069 18.0087 9.93343 17.9557 9.87319 17.8895L6.7508 14.4495C6.70874 14.4033 6.68097 14.3459 6.67089 14.2843C6.6608 14.2227 6.66883 14.1595 6.69399 14.1023C6.71915 14.0452 6.76037 13.9966 6.81263 13.9624C6.8649 13.9283 6.92596 13.91 6.9884 13.9099L21.6508 13.8979C21.7403 13.8979 21.8288 13.9167 21.9106 13.9529C21.9925 13.9891 22.0658 14.042 22.126 14.1083L25.2484 17.5483ZM9.87319 7.81025C9.93343 7.74404 10.0068 7.69112 10.0886 7.65489C10.1704 7.61866 10.2589 7.59991 10.3484 7.59985L25.0108 7.61185C25.0733 7.61198 25.1343 7.63024 25.1865 7.66441C25.2389 7.69857 25.2801 7.74718 25.3052 7.80433C25.3304 7.86148 25.3384 7.9247 25.3283 7.98632C25.3182 8.04793 25.2905 8.10529 25.2484 8.15145L22.126 11.5895C22.0657 11.6557 21.9923 11.7087 21.9105 11.7449C21.8285 11.7811 21.74 11.7999 21.6504 11.7999L6.9884 11.7879C6.92596 11.7877 6.8649 11.7695 6.81263 11.7353C6.76037 11.7011 6.71915 11.6525 6.69399 11.5954C6.66883 11.5383 6.6608 11.475 6.67089 11.4134C6.68097 11.3518 6.70874 11.2944 6.7508 11.2483L9.87319 7.81025Z"
        fill="white"
      />
    </svg>
  );
};

export default SOLIcon;
